export default __webpack_public_path__ + "static/media/Q_Quadrado.7bc9f9e6.mp3";